import React from 'react';
import p1 from '../../assets/revs/p001.webp';
import p2 from '../../assets/revs/p002.webp';
import p3 from '../../assets/revs/p003.webp';

const About = () => {
  return (
    <section id='about'>
      <div className='container'>
        <div className='s-48'></div>
        <h3 className='title-sub tc'>
          Start earning through nine IT lessons
        </h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma tc'>
          After completing the courses, we'll help you launch your IT career!
        </h4>
        <div className='s-48'></div>
        <div className='reviews bg-lpink'>
          <div className='row'>
            <div className='col-lg-7'>
              <div className='card-review first bg-white flex aifs p-4'>
                <img src={p1} alt='Natasha' width={40} heigt={40} />
                <div className='px-3'>
                  <h4 className='c-dark'>Natalia</h4>
                  <p style={{ minHeight: 40, paddingTop: 7 }}>
                    Hello! 
                    I came to Germany as a refugee and had no IT background. After completing the vibe-coding course,
                    I successfully transitioned into a tech career. The AI-assisted approach made programming accessible
                    even without prior experience. Now I work as a junior developer and can support my family. Thank you for this life-changing opportunity!
                  </p>
                </div>
              </div>
              <div className='s-24'></div>
              <div className='card-review second bg-white flex aifs p-4'>
                <img src={p2} alt='Snejana' width={40} heigt={40} />
                <div className='px-3'>
                  <h4 className='c-dark'>Snezhana</h4>
                  <p>
                    Thank you so much! I couldn't find work for over a year after arriving in Germany, but then
                    I retrained in DevOps using AI-assisted development and found a job within six weeks! The course taught me how to leverage AI tools
                    for faster learning and problem-solving. This was an amazing experience - thank you for everything and I wish success to all future students!
                  </p>
                </div>
              </div>
              <div className='s-24 d-none-d-sm-block'></div>
            </div>
            <div className='col-lg-5'>
              <div className='card-review third bg-white flex aifs p-4'>
                <img src={p3} alt='Youri' width={40} heigt={40} />
                <div className='px-3'>
                  <h4 className='c-dark'>Ingrid</h4>
                  <div className='s-10'></div>
                  <p style={{ paddingRight: 18 }}>
                    These courses completely changed my life!
                    I was working in a difficult profession and wanted to find a new path. The AI-assisted video creation and digital design courses were perfect for someone like me.
                    Now I work in the advertising industry creating compelling video content and digital campaigns using AI tools.
                    The transition was smoother than I ever imagined!
                    <br />
                    My advice to future students: don't be afraid to make a complete career change. These skills open doors to creative industries you never thought possible.
                    I went from a challenging situation to working with top advertising agencies in Berlin. The AI tools make everything achievable!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='s-48'></div>
      </div>
    </section>
  );
};

export { About };
